import { TRAILER_ACCESSIBILITY } from '../../../stores/types/chargers.interface';

export const formatSparkResultForClipboard = (data: any) => {
  if (!Array.isArray(data)) return '';

  return data
    .map((section) => {
      const sectionTitle = section.type ? `[${section.type}]` : '';
      let content = '';

      if (Array.isArray(section.content)) {
        content = section.content
          .map((item: any) => {
            return `${Object.entries(item)
              .map(([key, value]) => {
                if (Array.isArray(value)) {
                  return `${key}:\n${value.map((v) => `  - ${v}`).join('\n')}`;
                }
                return `${key}: ${value}`;
              })
              .join('\n')}\n`;
          })
          .join('\n');
      }

      return `${sectionTitle}\n${content}`;
    })
    .join('\n\n');
};

export const transformTrailerAccessibilityToString = (
  accessibility: TRAILER_ACCESSIBILITY,
): string => {
  switch (accessibility) {
    case TRAILER_ACCESSIBILITY.NOT_INDICATED:
      return 'not_indicated';
    case TRAILER_ACCESSIBILITY.ACCESSIBLE:
      return 'trailer_accessible';
    case TRAILER_ACCESSIBILITY.INACCESSIBLE:
      return 'not_trailer_accessible';
    default:
      return 'not_indicated';
  }
};
